/**
 * com.remedirx.apps.MyRemedi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ApiRequestDto } from '../model/apiRequestDto';
import { MedicationSummaryOwedMedicationResult } from '../model/medicationSummaryOwedMedicationResult';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class OwedMedicationService {

    protected basePath = 'http://localhost:3402';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Total list of Owed Medications
     * Return the current count of active medication alerts this person can see based on the selected organizational units        Sample Call      http://URL/api/OwedMedications/GetOwedMedication
     * @param requestParams Contains request parameters: orgList, sortFilterDto
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public owedMedicationGetOwedMedications(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<MedicationSummaryOwedMedicationResult>;
    public owedMedicationGetOwedMedications(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<MedicationSummaryOwedMedicationResult>>;
    public owedMedicationGetOwedMedications(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<MedicationSummaryOwedMedicationResult>>;
    public owedMedicationGetOwedMedications(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling owedMedicationGetOwedMedications.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<MedicationSummaryOwedMedicationResult>(`${this.basePath}/api/OwedMedications/GetOwedMedication`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Count of Owed Medications needed
     * Return the current count of active medication alerts this person can see based on the selected organizational units        Sample Call      http://URL/api/OwedMedications/OwedMedicationCount
     * @param requestParams Contains request parameters: orgList
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public owedMedicationGetOwedMedicationsCount(requestParams: ApiRequestDto, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public owedMedicationGetOwedMedicationsCount(requestParams: ApiRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public owedMedicationGetOwedMedicationsCount(requestParams: ApiRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public owedMedicationGetOwedMedicationsCount(requestParams: ApiRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (requestParams === null || requestParams === undefined) {
            throw new Error('Required parameter requestParams was null or undefined when calling owedMedicationGetOwedMedicationsCount.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'multipart/form-data',
            'application/xml',
            'text/xml',
            'application/x-www-form-urlencoded'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<number>(`${this.basePath}/api/OwedMedications/OwedMedicationCount`,
            requestParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
